import React from 'react';
import { PropTypes } from 'prop-types';
import { useFelaEnhanced } from '@ackee/fela';

import InputField from '../InputField';

import * as felaRules from './AnimatedInputField.styles';

export const AnimatedInputField = ({
    type,
    name,
    onBlur,
    onFocus,
    value,
    onChange,
    labelMessage,
    errors,
    textArea,
    disabled,
    hasError,
    notRequired,
    required,
    hint,
    formEventId,
    hidden,
}) => {
    const { rules } = useFelaEnhanced(felaRules);

    return (
        <InputField
            type={type}
            name={name}
            onBlur={onBlur}
            onFocus={onFocus}
            value={value}
            onChange={onChange}
            labelMessage={labelMessage}
            errors={errors}
            textArea={textArea}
            disabled={disabled || hidden}
            hasError={hasError}
            notRequired={notRequired}
            required={required}
            hint={hint}
            formEventId={formEventId}
            hidden={hidden}
            extend={{ container: rules.extendContainer }}
        />
    );
};

AnimatedInputField.propTypes = {
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    labelMessage: PropTypes.string.isRequired,
    errors: PropTypes.string,
    hasError: PropTypes.bool,
    textArea: PropTypes.bool,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    notRequired: PropTypes.bool,
    hint: PropTypes.string,
    formEventId: PropTypes.string,
    hidden: PropTypes.bool,
};

AnimatedInputField.defaultProps = {
    errors: null,
    textArea: false,
    hasError: false,
    disabled: false,
};
